import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=16175e1d&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16175e1d",
  null
  
)

export default component.exports